import { useNavigate } from 'react-router';
import { cn } from '@/lib/cn';
import type { NightsLayout } from './nightsGridUrlState';

/**
 * Calendar / Grid toggle of `/nights` (ids `admin.nights.view.calendar|grid`, `aria-pressed` on the active one).
 * Switching replaces the query string: the grid's own state is not carried to the calendar and back.
 */
export function NightsViewToggle({ layout }: { layout: NightsLayout }) {
  const navigate = useNavigate();
  return (
    <div
      className="inline-flex rounded-lg border border-gray-200 p-0.5 dark:border-white/10"
      role="group"
      aria-label="Nights layout"
    >
      {(['calendar', 'grid'] as const).map((l) => (
        <button
          key={l}
          type="button"
          id={`admin.nights.view.${l}`}
          aria-pressed={layout === l}
          onClick={() => {
            if (layout !== l)
              navigate(
                { search: l === 'grid' ? '?layout=grid' : '' },
                { replace: true },
              );
          }}
          className={cn(
            'rounded-md px-3 py-1.5 text-xs font-medium capitalize',
            layout === l
              ? 'bg-brand-500 text-white'
              : 'text-gray-600 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800',
          )}
        >
          {l === 'grid' ? 'Grid' : 'Calendar'}
        </button>
      ))}
    </div>
  );
}
